import request from 'api/requestUtils'
import { paths } from '@luxuryescapes/contract-cart'
import { mapMultiCartCreateResponse } from './multiCartMappers'

type UpdateMultiCartRequest = paths['/api/carts/multi-carts/{multiCartId}']['patch']['parameters']['body']['payload']
type UpdateMultiCartResponse = paths['/api/carts/multi-carts/{multiCartId}']['patch']['responses']['200']['content']['application/json']

export function updateMultiCartName(multiCartId: string, name: string): Promise<App.MultiCartSummary> {
  return request.patch<UpdateMultiCartResponse, UpdateMultiCartRequest>(`/api/carts/multi-carts/${multiCartId}`, { name }, { credentials: 'include' }).then(mapMultiCartCreateResponse)
}
